import {
    GET_SAVED_CAMPAIGNS,
    GET_SAVED_CAMPAIGNS_SUCCESS,
    GET_SAVED_CAMPAIGNS_FAILED,
} from './actionTypes';

export const getSavedCampaigns = () => {
    return {
        type: GET_SAVED_CAMPAIGNS
    }
}
export const getSavedCampaignsSuccess = (campaigns) => {
    return {
        type: GET_SAVED_CAMPAIGNS_SUCCESS,
        payload: campaigns
    }
}

export const getSavedCampaignsFailed= () => {
    return {
        type: GET_SAVED_CAMPAIGNS_FAILED
    }
}
